import { createSvgIcon } from '@mui/material/utils';

/**
 * 全局 Checkbox（MUI createSvgIcon）
 * - CHECKBOX_ICON_RX：圆角
 * - BOX：选中/未选中外轮廓一致；未选中描边内缩，避免比实心框大一圈
 */
export const CHECKBOX_ICON_RX = 4;

/** 外轮廓（24 视口内）；选中实心框占满此区域 */
export const BOX = { x: 5, y: 5, size: 15 };

export const BOX_STROKE_WIDTH = 2;

/** 未选中：描边居中在路径上，需内缩 stroke/2 才能与选中外廓对齐 */
function getOutlineRectProps(box = BOX, strokeWidth = BOX_STROKE_WIDTH) {
	const inset = strokeWidth / 2;
	return {
		x: box.x + inset,
		y: box.y + inset,
		width: box.size - strokeWidth,
		height: box.size - strokeWidth,
		rx: Math.max(0, CHECKBOX_ICON_RX - inset),
	};
}

export const CHECK_MARK_STROKE_WIDTH = 2;

export function getCheckMarkPathD(box = BOX) {
	const { x, y, size } = box;
	const px = (ratio) => x + size * ratio;
	const py = (ratio) => y + size * ratio;
	return `M${px(4.5 / 14)} ${py(7.5 / 14)} ${px(6.5 / 14)} ${py(9.5 / 14)} ${px(10.5 / 14)} ${py(5.5 / 14)}`;
}

function getIndeterminateBarProps(box = BOX) {
	const { x, y, size } = box;
	return {
		x: x + size * (3 / 14),
		y: y + size * (6 / 14),
		width: size * (8 / 14),
		height: Math.max(1.5, size * (2 / 14)),
		rx: size * (1 / 14),
	};
}

const outlineRect = getOutlineRectProps();

export const AppCheckBoxOutlineBlankIcon = createSvgIcon(
	<rect
		x={outlineRect.x}
		y={outlineRect.y}
		width={outlineRect.width}
		height={outlineRect.height}
		rx={outlineRect.rx}
		fill='none'
		stroke='currentColor'
		strokeWidth={BOX_STROKE_WIDTH}
	/>,
	'AppCheckBoxOutlineBlank',
);

export const AppCheckBoxIcon = createSvgIcon(
	<>
		<rect x={BOX.x} y={BOX.y} width={BOX.size} height={BOX.size} rx={CHECKBOX_ICON_RX} fill='currentColor' />
		<path d={getCheckMarkPathD(BOX)} fill='none' stroke='#fff' strokeWidth={CHECK_MARK_STROKE_WIDTH} strokeLinecap='round' strokeLinejoin='round' />
	</>,
	'AppCheckBox',
);

export const AppIndeterminateCheckBoxIcon = createSvgIcon(
	<>
		<rect x={BOX.x} y={BOX.y} width={BOX.size} height={BOX.size} rx={CHECKBOX_ICON_RX} fill='currentColor' />
		<rect fill='#fff' {...getIndeterminateBarProps(BOX)} />
	</>,
	'AppIndeterminateCheckBox',
);
